import React from 'react';
import Icon from '../../../components/AppIcon';

const SecurityMeasures = () => {
  const measures = [
    {
      icon: "Lock",
      title: "Data Encryption",
      description: "All data is encrypted in transit and at rest using industry-standard AES-256 encryption"
    },
    {
      icon: "Shield",
      title: "Secure Infrastructure",
      description: "Our servers are hosted in ISO 27001 certified data centers with 24/7 monitoring"
    },
    {
      icon: "Key",
      title: "Access Controls",
      description: "Multi-factor authentication and role-based access controls protect your information"
    },
    {
      icon: "Monitor",
      title: "Continuous Monitoring",
      description: "Real-time security monitoring and automated threat detection systems"
    },
    {
      icon: "FileCheck",
      title: "Regular Audits",
      description: "Third-party security audits and penetration testing conducted quarterly"
    },
    {
      icon: "Users",
      title: "Staff Training",
      description: "All employees receive regular privacy and security training with signed agreements"
    }
  ];

  return (
    <div className="space-y-6">
      <div className="text-center mb-8">
        <div className="w-16 h-16 bg-gradient-to-br from-primary to-accent rounded-full flex items-center justify-center mx-auto mb-4">
          <Icon name="ShieldCheck" size={32} color="white" />
        </div>
        <h3 className="text-xl font-poppins font-bold text-primary mb-2">
          Enterprise-Grade Security
        </h3>
        <p className="text-text-secondary max-w-2xl mx-auto text-sm leading-relaxed">
          We implement multiple layers of security to protect your personal information and maintain your trust.
        </p>
      </div>
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
        {measures?.map((measure, index) => (
          <div key={index} className="bg-card border border-border rounded-lg p-6 hover:liquid-shadow brand-transition">
            <div className="w-12 h-12 bg-primary/10 rounded-lg flex items-center justify-center mb-4">
              <Icon name={measure?.icon} size={24} className="text-primary" />
            </div>
            <h4 className="font-poppins font-semibold text-text-primary mb-2">
              {measure?.title}
            </h4>
            <p className="text-text-secondary text-sm leading-relaxed">
              {measure?.description}
            </p>
          </div>
        ))}
      </div>
    </div>
  );
};

export default SecurityMeasures;